import { useTheme } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';

export default function BreadCrumbsHomeIcon() {
  const theme = useTheme();

  const iconSX = {
    marginTop: -1,
    width: '1rem',
    height: '1rem',
    color: theme.palette.secondary.main,
  };

  return <HomeIcon style={iconSX} />;
}
